<template>
  <v-sheet flat border class="pa-4 col-sm-12">
    <p class="text-subtitle-1 pt-3 text-primary mb-3">
      <span class="font-weight-bold">Leak Sensor (v1)</span>
      - Input values at execution time
    </p>
    <v-row>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.CurrentDateTime"
          variant="outlined"
          density="compact"
          label="Current Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.ReadingDateTime"
          variant="outlined"
          density="compact"
          label="Reading Date/Time"
          type="datetime-local"
        />
      </v-col>
      <v-col sm="4">
        <v-text-field
          v-model="localInputData.DelayInMinutes"
          variant="outlined"
          density="compact"
          label="Delay in Minutes"
        />
      </v-col>
    </v-row>
    <BusinessHoursInput
      v-model:start-time="localInputData.SiteStartTime"
      v-model:end-time="localInputData.SiteEndTime"
    />
    <v-row>
      <v-col sm="6">
        <v-select
          v-model="localInputData.MonitorId"
          :items="leakSensorList"
          :item-title="(item) => item.Name || ''"
          :item-value="(item) => item.Id"
          data-testid="leak-sensor"
          label="Leak Sensor Name"
          variant="outlined"
          density="compact"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6">
        <v-select
          v-model="localInputData.ReadingValue"
          :items="readingValues"
          item-title="title"
          item-value="value"
          label="Leak Detected"
          hint="Clear to simulate a sensor without a reading"
          persistent-hint
          clearable
          variant="outlined"
          density="compact"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
import BusinessHoursInput from '@/Core.Service.Domain/Strategies/Strategies/Components/BusinessHoursInput.vue';
import { withBaseInputDefaults } from '@/Core.Service.Domain/Strategies/Strategies/Utils/baseInputDefaults.ts';

export default {
  name: 'LeakSensorV1Input',

  components: { BusinessHoursInput },

  data() {
    return {
      // the sensor reports 1 when it detects a leak and 0 when it doesn't
      readingValues: [
        { title: 'Yes', value: 1 },
        { title: 'No', value: 0 },
      ],
      localInputData: withBaseInputDefaults(this.InputData),
    };
  },

  props: {
    InputData: {
      type: Object,
      required: true,
    },
    DataSources: {
      type: Array,
      required: true,
    },
  },

  computed: {
    leakSensorList() {
      const leakSensors = this.DataSources.find(
        (d) => d.Key === 'LeakSensors'
      )?.Value;
      if (leakSensors?.length) return leakSensors;
      // without the site's leak sensors (e.g. replaying a run), offer the recorded one
      const friendlyName = this.localInputData.MonitorFriendlyName;
      return friendlyName
        ? [{ Id: this.localInputData.MonitorId, Name: friendlyName }]
        : [];
    },
  },

  watch: {
    'localInputData.MonitorId'(newMonitorId) {
      // the v-select only gives us the MonitorId (v-model), so keep the name in sync
      const selected = this.leakSensorList.find((s) => s.Id == newMonitorId);
      this.localInputData.MonitorFriendlyName = selected?.Name ?? null;
    },
    localInputData: {
      handler(newVal) {
        this.$emit('update:model', newVal);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
